import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SigninComponent} from './signin/signin.component';
import {SignupComponent} from './signup/signup.component';
import {AuthGuard} from './auth-guard.service';
import {AnonymousGuard} from './anonymous-guard.service';

const authRoutes: Routes = [
  {
    path: 'signin', component: SigninComponent, canActivate: [AnonymousGuard]
  },
  {
    path: 'signup', component: SignupComponent, canActivate: [AnonymousGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(authRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AuthRoutingModule {}
